import { CheckCircle, XCircle } from "lucide-react"

const ClientSurveyResponse = ({ data }) => {

    return (
        <div className="p-6 bg-white rounded-2xl shadow-md w-96 h-64">
            <h2 className="text-base font-semibold mb-4">Client Survey Responses</h2>
            <div className="space-y-4 overflow-y-auto pr-2">
                {data.length === 0 ?
                    <div className="flex justify-center items-center h-full">
                        No Data To Show
                    </div> : data.map((q, index) => (
                        <div key={index} className="flex items-center justify-between border-b pb-2 last:border-b-0">
                            <span className="text-gray-700">{q.question}</span>
                            {q.ans ? (
                                <CheckCircle className="text-green-500 w-6 h-6" />
                            ) : (
                                <XCircle className="text-red-500 w-6 h-6" />
                            )}
                        </div>
                    ))}
            </div>
        </div>
    )
}

export default ClientSurveyResponse
